export const APP_NAMESPACES = [
  "identity",
  "layout",
  "notifications",
] as const;

export type AppNamespace = (typeof APP_NAMESPACES)[number];
